<template>
  <div :id="id" :style="`height:${height};`"></div>
</template>

<script>
  import * as echarts from 'echarts'

  export default {
    name: 'Echart05',
    props: ['id', 'height', 'datas', 'color', 'reverse'],
    data() {
      return {
      }
    },
    watch: {
      datas: {
        deep: true,
        handler: function(newV, oldV) {
          if(!newV) return
          this.draw()
        }
      }
    },
    computed: {
      curColor() {
        let lj = this.datas.Lj
        return lj > 0 ?  '#39eef1' : 'rgba(255, 255, 255, .1)'
      }
    },
    mounted() {
      if(Object.keys(this.datas).length !== 0) {
        this.draw()
      }
    },
    methods: {
      draw() {
        if (document.getElementById(this.id) == null) {
          return
        }
        echarts.dispose(document.getElementById(this.id))
        const myChart = echarts.init(document.getElementById(this.id))
        let option = {
          color: [this.curColor, 'rgba(255, 255, 255, .1)'],
          grid: {
            containLabel: true
          },
          calculahte: true,
          series: [
            {
              type: 'pie',
              radius: ['74%', '78%'],
              avoidLabelOverlap: false,
              label: {
              	show: false,
                position: 'center',
              },
              labelLine: {
                show: false
              },
              data: [{
              	value: 100,
              	name: '预算',
              	label: {
              		fontSize: 18,
              		color: '#fff',
              		show: true,
              		padding: [8,0,0,0],
              		formatter: [
                    '{name|'+ this.datas.name +'}',
              			'{lj|累计金额: ' + (this.datas.Lj*1).toFixed(0) + '}',
              		].join('\n'),
              		rich: {
              			name: {
              				color: 'rgba(255, 255, 255, .8)',
              				fontSize: 14,
              				fontWeight: 'bold',
              				lineHeight: 20
              			},
              			lj: {
              				color: this.curColor,
              				fontSize: 14,
              				lineHeight: 28
              			}
              		},
              	},
              
              }, {
              	value: 0,
              	name: '累计实际',
              	label: {
              		show:false
              	}
              }]
            }
          ]
        }
        myChart.setOption(option, true)
      }
    }
  }
</script>

<style>
</style>

